import { isTaxEfficient } from './fund-info';
import { directLink } from './directLink';
import mStarCategoriesOrLocal from '../Context/useLocalMStarAsFallback';

export const morningstarTesters = {
    '4- and 5-star Funds': (f) =>
        [4, 5].includes(f.morningStarRatings.morningStarOverallRating),
    '3-star Funds': (f) => f.morningStarRatings.morningStarOverallRating === 3,
    '1- and 2-star Funds': (f) =>
        [1, 2].includes(f.morningStarRatings.morningStarOverallRating)
};

export const riskPotentialTesters = {
    'Lower (0%-4.5%)': (f) => f.riskLevel >= 200 && f.riskLevel <= 220,
    'Moderate (3.5%-16.5%)': (f) => f.riskLevel >= 230 && f.riskLevel <= 260,
    'Higher (15.5%-23.5%+)': (f) => f.riskLevel >= 270 && f.riskLevel <= 290
};

export const otherAttributesTesters = {
    'Investor Class': (f) => !f.iClass,
    'I Class': (f) => f.iClass,
    'Tax-Efficient': (f) => isTaxEfficient(f.name),
    'Open to New Investors': (f) => f.openToNewInvestors,
    'Closed to New Investors': (f) => !f.openToNewInvestors
};

export const selectFundTesters = {
    'Select Funds': (f) => f.selectFund
};

export const fTypeTesters = {
    'Stock Funds': (fund) =>
        directLink('stock-funds').filters.includes(
            mStarCategoriesOrLocal(fund)
        ),
    'Bond Funds': (fund) =>
        directLink('bond-funds').filters.includes(mStarCategoriesOrLocal(fund)),
    'Target Date Funds': (fund) =>
        directLink('target-date-funds').filters.includes(
            mStarCategoriesOrLocal(fund)
        ),
    'Allocation Funds': (fund) =>
        directLink('asset-allocation-funds').filters.includes(
            mStarCategoriesOrLocal(fund)
        ),
    'Money Market Funds': (fund) =>
        directLink('money-market-funds').filters.includes(
            mStarCategoriesOrLocal(fund)
        ),
    ETFs: (f) => f
};
